import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../utils/axiosInstance';
import { getAllOrdersAdmin, updateOrderStatus } from '../../constant/routes';
import './Admin.css';

const STATUS_OPTIONS = ['Pending', 'Processing', 'Shipped', 'Delivered', 'Cancelled'];

const statusClass = s => ({
    Pending:    'statusPending',
    Processing: 'statusPending',
    Shipped:    'statusShipped',
    Delivered:  'statusDelivered',
    Cancelled:  'statusCancelled',
}[s] || 'statusPending');

const AdminOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(null);

    const fetchOrders = async () => {
        setLoading(true);
        const res = await api.get(getAllOrdersAdmin).catch(e => e);
        if (res.status === 200) setOrders(res.data);
        setLoading(false);
    };

    useEffect(() => { fetchOrders(); }, []); // eslint-disable-line

    const handleStatusChange = async (orderId, newStatus) => {
        setUpdating(orderId);
        const res = await api
            .patch(updateOrderStatus + orderId, { status: newStatus })
            .catch(e => e);
        if (res.status === 200) {
            toast.success(`Status updated to ${newStatus}`);
            setOrders(prev =>
                prev.map(o => o._id === orderId ? { ...o, status: newStatus } : o)
            );
        } else {
            toast.error(res.message || 'Update failed');
        }
        setUpdating(null);
    };

    if (loading) return <p style={{ padding: '1rem' }}>Loading orders...</p>;

    return (
        <div className='adminSection'>
            <h2>All Orders ({orders.length})</h2>
            <table className='adminTable'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Customer</th>
                        <th>Items</th>
                        <th>Payment</th>
                        <th>Status</th>
                        <th>Date</th>
                        <th>Update</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order, i) => (
                        <tr key={order._id}>
                            <td>{i + 1}</td>
                            <td>
                                <strong>{order.userInfo?.userName}</strong>
                                <br />
                                <small>{order.userInfo?.userEmail}</small>
                            </td>
                            <td>{order.items?.length} item{order.items?.length !== 1 ? 's' : ''}</td>
                            <td>
                                {order.paymentMethod}
                                {order.paymentStatus && (
                                    <><br /><small style={{ color: 'green' }}>{order.paymentStatus}</small></>
                                )}
                            </td>
                            <td>
                                <span className={`statusBadge ${statusClass(order.status || 'Pending')}`}>
                                    {order.status || 'Pending'}
                                </span>
                            </td>
                            <td>
                                {order.orderPlaced
                                    ? new Date(order.orderPlaced).toLocaleDateString('en-GB', {
                                        day: 'numeric', month: 'short', year: 'numeric'
                                    })
                                    : '—'}
                            </td>
                            <td>
                                <select
                                    value={order.status || 'Pending'}
                                    onChange={e => handleStatusChange(order._id, e.target.value)}
                                    disabled={updating === order._id}
                                    style={{
                                        padding: '0.3rem',
                                        borderRadius: '4px',
                                        border: '1px solid #ddd',
                                        fontSize: '0.8rem',
                                    }}
                                >
                                    {STATUS_OPTIONS.map(s => (
                                        <option key={s} value={s}>{s}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminOrders;
